<template>
    <div class="dingdan">
        <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="订单编号" prop="sapCode" style="width: 50%;">
                            <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                        </el-form-item>
                        <el-form-item label="订单类型" prop="orderCategory1">
                            <el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
                                <el-option v-for="item in orderCategory1List"
                                           :key="item.code"
                                           :label="item.name"
                                           :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品编码/名称" prop="materialCode">
                            <el-input v-model="formInline.materialCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="采购订单号" prop="code"  style="width: 50%;">
                                    <el-input v-model="formInline.code" placeholder="多订单模糊查询请用空格或分号分隔"  ></el-input>
                                </el-form-item>
                                <el-form-item label="sap发票日期" class="ddqlcpicker" style="width: 50%;">
                                    <el-date-picker
                                            placeholder="请选择"
                                            v-model="formInline.startDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                    <span class="w-time-to">至</span>
                                    <el-date-picker
                                            placeholder="请选择"
                                            v-model="formInline.endDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                          <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="供应商编码" prop="suserCode">
                              <el-input v-model="formInline.suserCode" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="进项发票号" prop="invoiceNumber">
                              <el-input v-model="formInline.invoiceNumber" placeholder="请输入"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                    </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30 tableclslist">
            <el-table
                    ref="ddtable"
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    @selection-change="handleSelectionChange"
                    stripe
                    border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
                    max-height="450"
            >
                <el-table-column
                        type="selection"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        type="index"
                        width="40"
                        label="#"
                        fixed
                >
                </el-table-column>
                <el-table-column
                        fixed
                        prop="add3"
                        label="交货单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        fixed
                        prop="sapCode"
                        label="销售订单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="orderCategory1"
                        label="销售订单类型"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template scope="scope">
                        {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="code"
                        label="采购单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="cgSapCode"
                        label="sap采购订单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="suserCode"
                        label="供应商编码"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="suserName"
                        label="供应商名称"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="ycid"
                        label="预测订单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品型号"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="销售数量"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="chineseName"
                        label="中文品名"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="declarationName"
                        label="报关型号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="primaryUom"
                        label="基本单位"
                        :show-overflow-tooltip="true"
                        width="80">
                    <template scope="scope">
                        {{scope.row.primaryUom|dictname('YLUnit') }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="count"
                        label="数量"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="customsCode"
                        label="报关单号"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="fhdate"
                        label="发货日期"
                        :show-overflow-tooltip="true"
                        :formatter="formatDate"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="billDate"
                        label="出口日期"
                        :show-overflow-tooltip="true"
                        :formatter="formatDate"
                        width="120">
                </el-table-column>
                <el-table-column
                    prop="taxUnitPrice"
                    label="不含税单价"
                    :show-overflow-tooltip="true"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="amountAll"
                    label="不含税金额汇总"
                    :show-overflow-tooltip="true"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="taxAmount"
                    label="税额"
                    :show-overflow-tooltip="true"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="invoiceNumber"
                    label="进项发票号"
                    :show-overflow-tooltip="true"
                    width="120">
                </el-table-column>
                <el-table-column
                        prop="add4"
                        label="金税发票号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="add5"
                        label="sap发票日期"
                        :show-overflow-tooltip="true"
                        :formatter="formatDate"
                        width="120">
                </el-table-column>
                <el-table-column
                    label="报关单">
                  <template slot-scope="scope">
                    <brupload
                        style="margin-top: 0.1rem;"
                        :showtime="false"
                        :refid="scope.row.sapCode"
                        reftype="WXFJ_BGD"
                        :tpFlag = 'true'
                    />
                  </template>
                </el-table-column>
            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="formInline" @query="query"/>
                <div style="display:flex;align-items: center;">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportExcel">批量导出
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    export default {
        props: ["firstPageFlag"],
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    sapCode:null,
                    orderCategory1:null,
                    code:null,
                    materialCode:null,
                    startDate:null,
                    endDate:null,
                },
                tableData:[],
                orderCategory1AllList:[],
                orderCategory1List:[],
            }
        },
        created() {
            this.query();
            this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
            this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:'20191025hQ7mNd95'});
        },
        methods: {
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                ss.OrderMainService.seletTuishuiInvoicePage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //合并
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

            },
            getSpanArr(){

            },
            // 重置按钮
            resetData() {
                this.formInline.sapCode = null;
                this.formInline.pageNo = 1;
                this.formInline.code = null;
                this.formInline.materialCode = null;
                this.formInline.startDate = null;
                this.formInline.endDate = null;
            },
            //批量导出
            exportExcel() {
                var form = _.clone(this.formInline);
                updownfile.down("/api/swyl/v1/tuishuiInvoice/downloadExcel", form, "post");
            },
            //日期格式化
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
        },
    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }
    .tableclslist	.h-tableLink{
        padding:0px 2px!important;
    }
</style>
<style>
    .h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label{
        width: 20%;
    }
    .h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content{
        width: 80%;
    }
</style>
